import { useLabels } from "../hooks";
import { breadcrumb } from "../layerTreeModel";
import type { TreeRow } from "../layerTreeModel";
import { Icon } from "../icons";
import { Button } from "../primitives/Button";

export type LayerGroupProps = {
  row: TreeRow;
  onToggle: () => void;
  onExpand: (expanded: boolean) => void;
};

export function LayerGroup({ row, onToggle, onExpand }: LayerGroupProps) {
  const labels = useLabels();
  const mixed = row.state === "some";

  return (
    <div
      className={["fxmap-group", row.expanded ? "fxmap-group-expanded" : "", row.loading ? "fxmap-group-loading" : "", row.error ? "fxmap-group-error" : ""].filter(Boolean).join(" ")}
      data-fxmap="layer-group"
      data-fxmap-layer={row.id}
      title={breadcrumb(row.entry)}
    >
      <Button
        kind="icon"
        size="sm"
        icon={row.expanded ? "chevronDown" : "chevronRight"}
        label={row.entry.name}
        className="fxmap-group-chevron"
        aria-expanded={row.expanded}
        tabIndex={-1}
        onClick={event => {
          event.stopPropagation();
          onExpand(!row.expanded);
        }}
      />
      {row.single ? (
        <span className="fxmap-group-marker fxmap-group-marker-single" aria-hidden="true" />
      ) : (
        <input
          className="fxmap-row-check"
          type="checkbox"
          checked={row.state === "all"}
          ref={element => {
            if (element !== null) element.indeterminate = mixed;
          }}
          aria-label={row.entry.name}
          tabIndex={-1}
          onChange={onToggle}
          onClick={event => event.stopPropagation()}
        />
      )}
      <Icon name={row.entry.root === "maps" && row.level === 1 ? "map" : "folder"} className="fxmap-group-icon" />
      <span
        className="fxmap-group-name fxmap-display fxmap-truncate"
        onClick={event => {
          event.stopPropagation();
          onExpand(!row.expanded);
        }}
      >
        {row.entry.name}
      </span>
      {row.error ? <span className="fxmap-group-dot fxmap-group-dot-error" title={labels.loadFailed} aria-label={labels.loadFailed} role="img" /> : null}
      {row.loading ? <span className="fxmap-group-dot fxmap-group-dot-loading" title={labels.loading} aria-label={labels.loading} role="img" /> : null}
      <span className="fxmap-group-count fxmap-tabular fxmap-muted">{row.single ? "" : `${row.selectedCount}/${row.totalCount}`}</span>
    </div>
  );
}
